<template>
  <div id="footer" class="footer">
     <span><a href="https://sci-fund.ai" target="_blank">sci-fund.ai</a> // <a href="https://sci-fund.ai/terms-of-service" target="_blank">Terms of service</a> // <a href="mailto:support@sci-fund.ai" target="_blank">Need support?</a></span>
     <span class="float-right">&copy; CONTEXITY</span>
  </div>
</template>

<script>
export default {
  name: 'PageFooter',
  data () {
    return {
    }
  },
  components: {
  },
  computed: {

  }
}
</script>

<style scoped>
  .footer {
    margin-top: 40px;
    background-color: #f7f7f7;
    padding: 20px 80px;
    min-height: 150px;
  }
</style>
